import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["row", "segment", "input", "empty", "count", "secret"];

  connect() {
    const checked = this.segmentTargets.find((s) => s.checked);
    this.activeKind = checked?.dataset.kind || "all";
  }

  search() {
    this.#apply();
  }

  clear(event) {
    if (event.key === "Escape") {
      this.inputTarget.value = "";
      this.#apply();
    }
  }

  selectKind() {
    const checked = this.segmentTargets.find((s) => s.checked);
    this.activeKind = checked?.dataset.kind || "all";
    this.#apply();
  }

  #apply() {
    const query = (this.inputTarget?.value || "").toLowerCase();
    let shown = 0;
    const total = this.rowTargets.length;

    this.rowTargets.forEach((row) => {
      const matchesKind =
        this.activeKind === "all" || row.dataset.kind === this.activeKind;
      const matchesText =
        !query || (row.dataset.search || "").toLowerCase().includes(query);
      const visible = matchesKind && matchesText;
      row.style.display = visible ? "" : "none";
      if (visible) shown++;

      // Hide any secret panel tied to this row
      if (this.hasSecretTarget) {
        this.secretTargets.forEach((s) => {
          if (s.dataset.secretFor === row.id) {
            s.style.display = visible ? "" : "none";
          }
        });
      }
    });

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("d-none", shown !== 0);
    }
    if (this.hasCountTarget) {
      this.countTarget.textContent = `${shown} of ${total} shown`;
    }
  }
}
